import React from 'react';

import { RowListSkeleton } from 'app/component/skeleton/row/RowListSkeleton';
import { FlexibleSkeleton } from 'app/component/skeleton/flexible/FlexibleSkeleton';
import { RepeatComponent } from 'app/component/repeat-component/RepeatComponent';
import { FieldSkeleton } from 'app/component/skeleton/field/FieldSkeleton';
import { useIsDesktop, useWindowType } from 'app/utils/useWindowType';

export const EmploymentSkeleton = () => {
    const [windowType] = useWindowType();
    const [isDesktop] = useIsDesktop();

    return (
        <div className="employmentSkeleton">
            {isDesktop ? (
                <>
                    <div style={{ height: 40 }}>
                        <FlexibleSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 32, height: 32, width: 224 }}>
                        <FlexibleSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 32, height: 48 }}>
                        <FlexibleSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 24, height: 48, width: 182 }}>
                        <FlexibleSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 48, height: 32, width: 224 }}>
                        <FlexibleSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 32 }}>
                        <FieldSkeleton windowType={windowType} />
                    </div>
                    <RepeatComponent numberRepetitions={3}>
                        <div style={{ marginTop: 24 }}>
                            <FieldSkeleton windowType={windowType} />
                        </div>
                    </RepeatComponent>
                </>
            ) : (
                <>
                    <div style={{ height: 40 }}>
                        <FlexibleSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 32, height: 32 }}>
                        <FlexibleSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 32, height: 48 }}>
                        <FlexibleSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 8 }}>
                        <RepeatComponent numberRepetitions={3}>
                            <div style={{ marginTop: 24 }}>
                                <RowListSkeleton
                                    rowCount={1}
                                    windowType={windowType}
                                />
                            </div>
                        </RepeatComponent>
                    </div>
                    <div style={{ marginTop: 32 }}>
                        <FieldSkeleton windowType={windowType} />
                    </div>
                    <div style={{ marginTop: 24 }}>
                        <FieldSkeleton windowType={windowType} />
                    </div>
                </>
            )}
        </div>
    );
};
